// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-double"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M7.5 10.125V20.25L12 18.375L16.5 21L21 18.375V8.25L16.5 10.125L12 7.5L7.5 10.125Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12 7.5L7.5 10.125V13.875L3 15.75V5.625L7.5 3L12 5.625L16.5 3.75L16.5 10.125L12 7.5Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 7.5L7.5 10.125V13.875L3 15.75V5.625L7.5 3L12 5.625L16.5 3.75L16.5 10.125L12 7.5Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 17.625V8.25M16.5 10.9V20.25M7.5 20.25V10.125L12 7.5L16.5 10.125L21 8.25V18.375L16.5 21L12 18.375L7.5 20.25Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapDoubleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-double',
    ref,
    icon: element,
  },
));

MapDoubleIcon.displayName = 'MapDoubleIcon';

export default MapDoubleIcon;
